import script from "./SearchPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchPanel.vue?vue&type=script&lang=ts&setup=true"

import "./SearchPanel.vue?vue&type=style&index=0&id=fb93ddde&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb93ddde"]])

export default __exports__